// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cdJw","label":"styles_label__2ZLqv"};